import React, { useEffect, useState } from 'react';
import Loadable from '../Loadable';

const RequestIndicator = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const showSpinner = () => setShow(true);
    const hideSpinner = () => setShow(false);

    document.addEventListener('show-spinner', showSpinner);
    document.addEventListener('hide-spinner', hideSpinner);

    return () => {
      document.removeEventListener('show-spinner', showSpinner);
      document.removeEventListener('hide-spinner', hideSpinner);
    };
  }, []);

  if (!show) return null;

  return <Loadable loading={true} floating />;
}; 

export default RequestIndicator;